import React, { FC } from 'react';
import { ListItemText } from '@material-ui/core';

import { ClientLocation } from 'api';

interface IProps {
  location: ClientLocation;
}

const LocationItem: FC<IProps> = ({ location }) => (
  <ListItemText primaryTypographyProps={{ color: 'inherit' }} primary={location.title} />
);

export default LocationItem;
